export default __webpack_public_path__ + "static/media/cal05.f83ddb4f.svg";